<template>
  <introduce-page>
    <div style="width: 100%;">
      <el-row v-for="(detail, i) in dataList" :key="i" style="width: 100%;">
        <div v-if="detail.contentType === 0" style="line-height: 30px;white-space: pre-wrap;text-align: justify;text-indent: 2em;">{{detail.content}}</div>
        <el-row v-else-if="detail.contentType === 1" style="margin-top: 16px;margin-bottom: 16px;width: 100%;">
          <el-image :src="detail.content" style="width: 100%;"></el-image>
        </el-row>
      </el-row>
    </div>
  </introduce-page>
</template>

<script>
import IntroducePage from './IntroducePage'
export default {
  name: 'ShortIntroduce',
  components: { IntroducePage },
  data() {
    return {
      dataList: [
        {'contentType': 0, 'content': '瑜岿科技是一家专注于能源互联网、园区物联网产品及解决方案研发的创新型科技公司。为企业和集成商提供能源物联网云平台、智慧园区云平台、智能用电、多能互补、智慧运维、电能质量治理等系统解决方案以及相关的智能传感、测控装置。业务主要涉及以下三大领域：综合能源服务、智慧园区、分布式光伏。'},
        {'contentType': 0, 'content': '公司位于中国光谷创业街，研发团队由华科、根特大学、西工大、哈工大、武汉理工等名校毕业的技术精英组成，在能源电力、物联网、大数据领域拥有多年的技术研发和设计经验。与华中科技大学、武汉大学有深度合作，聘请了多位知名教授、千人专家及留洋博后为公司技术顾问。'},
        {'contentType': 0, 'content': '公司坚持以客户为中心，以产品为核心，以创新为驱动，让绿色能源、智慧服务触手可及。'},
        {'contentType': 1, 'content': require('../../assets/company.jpg')}
      ]
    }
  },
  created() {
    document.documentElement.scrollTop = 0
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/introduce/ShortIntroduce.vue